<template>
  <div id="customers">
    <v-card max-width="100%" outlined>
      <v-row no-gutters class="align-center">
        <v-card-title class="text-h4"> Teacher Profiles </v-card-title
        ><v-spacer></v-spacer>
        <v-btn
          class="mr-3"
          @click="openCreateTeacherDialog"
          :disabled="creatingUser || !initiallyLoaded"
          :loading="creatingUser"
          >Create Teacher</v-btn
        >
        <v-btn
          class="mr-3"
          to="/retrieveuserlogin"
          :disabled="creatingUser || !initiallyLoaded"
          :loading="creatingUser"
          >Retrieve Login</v-btn
        >
        <!-- <v-btn
          class="mr-3"
          @click="deleteNonTeacherOrAdminUsers(false)"
          :disabled="
            creatingReportingData ||
            !initiallyLoaded||
            !userGroups?.includes('superadmin')
          "
          :loading="creatingReportingData"
          >Delete cognito users</v-btn
        > -->
        <v-btn
          class="mr-3"
          @click="updateSmartProductSort"
          :disabled="
            creatingUser ||
            !initiallyLoaded ||
            !userGroups?.includes('superadmin')
          "
          :loading="creatingUser"
          >Admin function</v-btn
        >
        <v-btn
          class="mr-3"
          @click="createOrUpdateReportingTeacherEmails"
          :disabled="
            creatingReportingData ||
            !initiallyLoaded ||
            !userGroups?.includes('superadmin')
          "
          :loading="creatingReportingData"
          >Create Reporting Data</v-btn
        >
        <v-btn
          class="mr-3"
          @click="createOrUpdateReportingTeacherTags"
          :disabled="
            creatingReportingTags ||
            !initiallyLoaded ||
            !userGroups?.includes('superadmin')
          "
          :loading="creatingReportingTags"
          >Create Reporting Tags</v-btn
        >
      </v-row>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-card-title>
      <div class="px-4">
        <v-data-table
          :footer-props="{
            showFirstLastPage: true,
          }"
          :headers="headers"
          :items="filteredReportingTeacherArray"
          :sort-desc="sortDesc"
          :sort-by="sortBy"
          must-sort
          :search="search"
          :loading="
            !syncedReportingTeachers &&
            syncedReportingTeacherArray?.length === 0
          "
          loading-text="Loading Customers..."
          no-data-text="No Customers found"
        >
          <template v-slot:[`item.registrationDate`]="{ item }">
            {{ formatDate(item.registrationDate) }}
          </template>
          <template v-slot:[`item.owner`]="{ item }">
            {{ item.owner?.split("::").pop() }}
          </template>
          <template v-slot:[`item.teacherProfileSchoolId`]="{ item }">
            {{
              item.teacherProfileSchoolId
                ? schoolName(item.teacherProfileSchoolId)
                : ""
            }}
          </template>
          <!-- <template v-slot:[`item.productSubscriptions`]="{ item }">
            {{
              item.productSubscriptions?.length > 0
                ? [...new Set(JSON.parse(item.productSubscriptions))].length
                : 0
            }}
          </template> -->

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="openCustomerProductOrders(item)"
                  :disabled="offline"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-book-open
                </v-icon>
              </template>
              <span>View Orders</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="addCustomerProductOrders(item)"
                  :disabled="offline"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-book-plus-multiple-outline
                </v-icon>
              </template>
              <span>New Order</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="openCustomerProductOrderQuotes(item)"
                  :disabled="offline"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-basket-outline
                </v-icon>
              </template>
              <span>View Quotes</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="addCustomerProductOrderQuotes(item)"
                  :disabled="offline"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-basket-plus-outline
                </v-icon>
              </template>
              <span>New Quote</span>
            </v-tooltip>
            <!-- <v-icon small @click="convertProducts(item)" :disabled="offline">
              mdi-account-convert
            </v-icon>
            <v-icon
              small
              @click="removeDuplicateProducts(item)"
              :disabled="offline"
            >
              mdi-content-duplicate
            </v-icon> -->
          </template>
        </v-data-table>
      </div>
    </v-card>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-form ref="form" v-model="valid" @submit.prevent="createUser">
          <v-card-title>
            <span class="text-h5">Create teacher</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.email"
                    label="Email"
                    :rules="formRules.email"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.phone"
                    label="Phone"
                    :rules="formRules.phoneNumber"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-alert
                v-show="creatingUserResponseText > ''"
                dense
                :type="creatingUserResponseType"
                class="mb-0"
              >
                <v-row align="center">
                  <v-col class="grow text-subtitle-1">{{
                    creatingUserResponseText
                  }}</v-col>
                </v-row>
              </v-alert>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="close" :disabled="creatingUser">
              Close
            </v-btn>
            <v-btn
              :disabled="!valid || creatingUser"
              :loading="creatingUser"
              color="primary"
              @click="createUser"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Auth, API, DataStore } from "aws-amplify";
import AWS from "aws-sdk";
import {
  School,
  Secret,
  Product,
  TeacherProfile,
  ProductCategory,
  ReportingTeacher,
  TeacherProductsOrder,
  TeacherClassSubject,
  Subject,
} from "@/models";
import _ from "lodash";
import pako from "pako";
// import { Buffer } from "buffer";
import store from "@/store";
import { reconfigureDatastore } from "@/plugins/datastore/config.js";

export default {
  name: "AdminCustomers",
  data: () => ({
    creatingReportingData: false,
    creatingReportingTags: false,

    creatingUser: false,
    creatingUserResponseText: "",
    creatingUserResponseType: "error",
    valid: false,
    dialog: false,

    initiallyLoaded: false,
    syncedCustomerArray: [],

    // reportingTeacherSubscription: null,
    syncedReportingTeacherArray: [],
    syncedReportingTeachers: false,

    // teacherProfileSubscription: null,
    syncedTeacherProfileArray: [],
    teacherProfiles: [],
    teacherProfileSubscriptionSynced: false,

    // secretSubscription: null,
    syncedSecretArray: [],
    secretSubscriptionSynced: false,

    // schoolSubscription: null,
    syncedSchoolArray: [],
    schoolSubscriptionSynced: false,

    syncedTeacherProductsOrderArray: [],
    syncedTeacherProductsOrders: false,

    syncedProductCategoryArray: [],
    syncedProductCategories: false,

    sortBy: "registrationDate",
    sortDesc: true,
    search: "",
    headers: [],
    // customers: [],
    editedIndex: -1,
    editedItem: {
      email: "",
      phone: "",
    },
    defaultItem: {
      email: "",
      phone: "",
    },
    formRules: {
      email: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneNumber: [
        (v) =>
          !v ||
          /^(?:\+27|0)\s?\d{2}\s?\d{3}\s?\d{4}$/.test(v) ||
          "Invalid South African phone number",
      ],
    },
  }),

  async mounted() {
    try {
      store.commit("changeDatastorePredicates", [
        {
          model: "School",
          predicate: "Admin",
        },
        {
          model: "ReportingTeacher",
          predicate: "Admin",
        },
        {
          model: "Secret",
          predicate: "SuperAdmin",
        },
        {
          model: "TeacherProfile",
          predicate: "SuperAdmin",
        },
        // { model: "TeacherProductsOrder", predicate: "SuperAdmin" },
        { model: "ProductCategory", predicate: "Admin" },
      ]);

      if (!this.startedDatastoreSync || this.datastoreReady) {
        reconfigureDatastore();
      }

      this.headers = [
        {
          text: "Username",
          value: "owner",
          sort: (a, b) => this.customSortOwner(a, b),
        },
        {
          text: "Registration Date",
          value: "registrationDate",
        },
        {
          text: "Email",
          value: "email",
        },
        { text: "Title", value: "title" },
        { text: "Name", value: "name" },
        { text: "Surname", value: "surname" },
        { text: "Phone", value: "phone", sortable: false },
        { text: "User Group(s)", value: "roles" },
        // {
        //   text: "Subscription Status",
        //   value: "payfastSubscriptionResponse",
        //   sort: (a, b) => this.customSortPayfastStatus(a, b),
        // },
        { text: "Province", value: "province" },
        { text: "Language", value: "language" },
        { text: "School", value: "teacherProfileSchoolId" },
        // {
        //   text: "Products",
        //   value: "productSubscriptions",
        //   sort: (a, b) => this.customSortProducts(a, b),
        // },
        { text: "Actions", value: "actions", sortable: false },
      ];

      if (!this.changingDatastoreConfig) {
        // Get the Customers
        this.syncReportingTeachers();
        this.syncSchools();
        this.syncSecrets();
        // await this.getCustomers();
        if (this.userGroups?.includes("superadmin")) {
          this.syncTeacherProfiles();
          this.syncTeacherProductsOrders();
          this.syncProductCategories();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (!this.initiallyLoaded) {
        this.initiallyLoaded = true;
      }
    }
  },

  computed: {
    ...mapState({
      offline: (state) => !state.isOnline,
      userGroups: (state) => state.userGroups,
      changingDatastoreConfig: (state) => state.changingDatastoreConfig,
      datastoreReady: (state) => state.datastoreReady,
      startedDatastoreSync: (state) => state.startedDatastoreSync,
    }),

    schoolName() {
      return (schoolId) => {
        const school = _.find(this.syncedSchoolArray, { id: schoolId });
        return school ? school.name : "";
      };
    },

    filteredReportingTeacherArray() {
      return (
        this.syncedReportingTeacherArray?.filter(
          (item) =>
            item.roles?.includes("teacher") || item.roles?.includes("admin"),
        ) || []
      );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    changingDatastoreConfig: {
      async handler(newVal, oldVal) {
        // console.log("watch changingDatastoreConfig", newVal, oldVal);

        if (newVal === true) {
          return;
        }

        if (newVal === false && oldVal === true) {
          this.syncReportingTeachers();
          this.syncSchools();
          this.syncSecrets();

          if (this.userGroups?.includes("superadmin")) {
            this.syncTeacherProfiles();
            this.syncTeacherProductsOrders();
            this.syncProductCategories();
          }
        }
      },
    },

    userGroups: {
      handler(val) {
        // console.log("userGroups", val);
        if (val?.length > 0 && !this.changingDatastoreConfig) {
          if (val.includes("superadmin")) {
            this.syncTeacherProfiles();
            this.syncTeacherProductsOrders();
            this.syncProductCategories();
          }

          this.syncSecrets();
        } else if (
          val?.length > 0 &&
          !val.includes("superadmin")
          // &&
          // (this.teacherProfileSubscription || this.secretSubscription)
        ) {
          // this.teacherProfileSubscription.unsubscribe();
          this.syncedTeacherProfileArray = [];
          this.teacherProfileSubscriptionSynced = false;

          // this.secretSubscription.unsubscribe();
          // this.syncedSecretArray = [];
          // this.secretSubscriptionSynced = false;
        }
      },
      immediate: true,
    },
  },

  methods: {
    async updateSmartProductSort() {
      try {
        const updateTeacherProfile = /* GraphQL */ `
          mutation UpdateTeacherProfile(
            $input: UpdateTeacherProfileInput!
            $condition: ModelTeacherProfileConditionInput
          ) {
            updateTeacherProfile(input: $input, condition: $condition) {
              id
              smartProductSort
              createdAt
              updatedAt
              _version
            }
          }
        `;

        console.log("Querying all data...");

        const profiles = await DataStore.query(TeacherProfile);
        console.log(`Found ${profiles.length} teacher profiles.`);

        const allOrders = await DataStore.query(TeacherProductsOrder);
        console.log(`Found ${allOrders.length} orders.`);

        const allClassSubjects = await DataStore.query(TeacherClassSubject);
        console.log(`Found ${allClassSubjects.length} class subjects.`);

        const allCategories = await DataStore.query(ProductCategory);
        const categoryMap = new Map(allCategories.map((c) => [c.id, c.grade]));

        const allSubjects = await DataStore.query(Subject);
        const subjectMap = new Map(allSubjects.map((s) => [s.id, s.grade]));
        console.log(`Found ${allSubjects.length} subjects.`);

        const ordersByProfile = allOrders.reduce((acc, order) => {
          const pid = order.teacherprofileID;
          if (!acc[pid]) acc[pid] = [];
          acc[pid].push(order);
          return acc;
        }, {});

        const classSubjectsByProfile = allClassSubjects.reduce((acc, cs) => {
          const pid = cs.teacherprofileID;
          if (!acc[pid]) acc[pid] = [];
          acc[pid].push(cs);
          return acc;
        }, {});

        for (let i = 0; i < profiles.length; i++) {
          const profile = profiles[i];

          console.log(
            `Processing profile ${profile.id} (${i + 1}/${profiles.length})`,
          );

          const orders = ordersByProfile[profile.id] || [];
          const classSubjects = classSubjectsByProfile[profile.id] || [];

          let grades = new Set();
          let categories = new Set();

          // From class subjects
          for (const cs of classSubjects) {
            const grade = subjectMap.get(cs.subjectID);
            if (grade) {
              grades.add(grade);
            }
          }

          // From orders
          for (const order of orders) {
            if (order.orderProducts) {
              for (const prod of order.orderProducts) {
                if (prod.categoryId) {
                  categories.add(prod.categoryId);
                  const grade = categoryMap.get(prod.categoryId);
                  if (grade) {
                    grades.add(grade);
                  }
                }
              }
            }
          }

          if (grades.size === 0 && categories.size === 0) {
            console.log(
              `No grades or categories found for profile ${profile.id} (${
                i + 1
              }/${profiles.length}), skipping update.`,
            );
            continue;
          }

          const newSmartSorted = {
            grades: Array.from(grades).sort((a, b) => a.localeCompare(b)),
            categories: Array.from(categories).sort((a, b) =>
              a.localeCompare(b),
            ),
          };

          const existing = profile.smartProductSort || {
            grades: [],
            categories: [],
          };
          const existingSorted = {
            grades: [...(existing.grades || [])].sort((a, b) =>
              a.localeCompare(b),
            ),
            categories: [...(existing.categories || [])].sort((a, b) =>
              a.localeCompare(b),
            ),
          };

          if (
            JSON.stringify(newSmartSorted) === JSON.stringify(existingSorted)
          ) {
            console.log(
              `Skipping profile ${profile.id} (${i + 1}/${
                profiles.length
              }) as smartProductSort is the same.`,
            );
            continue;
          }

          const smart = {
            grades: Array.from(grades),
            categories: Array.from(categories),
          };

          // Mutate using AppSync
          const input = {
            id: profile.id,
            _version: profile._version,
            smartProductSort: JSON.stringify(smart),
          };

          await API.graphql({
            query: updateTeacherProfile,
            variables: { input },
            authMode: "AMAZON_COGNITO_USER_POOLS",
          });

          console.log(
            `Updated profile ${profile.id} (${i + 1}/${profiles.length})`,
          );
        }

        console.log("Update complete.");
      } catch (error) {
        console.error("Error updating smartProductSort:", error);
      }
    },

    openCreateTeacherDialog() {
      this.resetForm();
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },

    resetForm() {
      if (this.$refs.form) this.$refs.form.reset();
      this.valid = false;
    },

        async createUser() {
      try {
        this.creatingUserResponseText = "";
        this.creatingUser = true;

        const user = await Auth.currentAuthenticatedUser().catch(() => {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        });

        const userPoolId = user.pool.userPoolId;

        const email = this.editedItem.email.trim().replaceAll(" ", "");
        const phoneNumber = this.editedItem.phone?.replace(/^0/, "+27") || "";

        const getTeacherResponse = await API.get(
          "adminlambdaapi",
          "/item/queryTeacherProfile",
          {
            queryStringParameters: {
              userPoolId: userPoolId,
              userName: user.username,
              teacherEmail: email,
            },
          },
        ).catch((error) => {
          console.log(error);
        });

        console.log("getTeacherResponse", getTeacherResponse);

        if (!getTeacherResponse?.teacherProfileDetails) {
          this.creatingUser = false;
          this.creatingUserResponseType = "error";
          this.creatingUserResponseText = getTeacherResponse?.errorMessage;
          return;
        }

        const teacherProfileResponse =
          getTeacherResponse.teacherProfileDetails.teacherprofile;

        const existingReportingTeacher = this.syncedReportingTeacherArray?.find(
          (item) => item.teacherprofileID === teacherProfileResponse?.id,
        );

        if (existingReportingTeacher) {
          this.creatingUser = false;

          if (
            existingReportingTeacher?.roles?.includes("teacher") ||
            existingReportingTeacher?.roles?.includes("admin")
          ) {
            this.creatingUserResponseType = "warning";
            this.creatingUserResponseText = "Teacher already exists";
            this.search = email;
          } else {
            this.creatingUserResponseType = "warning";
            this.creatingUserResponseText =
              "Teacher already exists but isn't in the 'teacher' group (Hasn't used the new system yet but imported from old site)";
          }

          return;
        }

        const datamodelCognitoOwner =
          getTeacherResponse.teacherProfileDetails.datamodelCognitoOwner ||
          null;

        const createTeacherResponse = await API.post(
          "cognitolambdaapi", // <-- replace with your cognito lambda's API name
          "/item/createTeacherUser",
          {
            body: {
              email: email,
              phoneNumber: phoneNumber,
              datamodelCognitoOwner: datamodelCognitoOwner,
              teacherProfile: teacherProfileResponse
                ? {
                    id: teacherProfileResponse.id,
                    title: teacherProfileResponse.title,
                    name: teacherProfileResponse.name,
                    surname: teacherProfileResponse.surname,
                    province: teacherProfileResponse.province,
                    createdAt: teacherProfileResponse.createdAt,
                    teacherProfileSchoolId:
                      teacherProfileResponse.teacherProfileSchoolId,
                  }
                : null,
            },
          },
        ).catch((error) => {
          console.log(error);
          return error?.response?.data;
        });

        console.log("createTeacherResponse", createTeacherResponse);

        if (!createTeacherResponse?.success) {
          this.creatingUser = false;
          this.creatingUserResponseType = "error";
          this.creatingUserResponseText =
            createTeacherResponse?.error?.message ||
            "Network error please reload and try again - No user created";
          return;
        }

        this.creatingUserResponseType = "success";
        this.creatingUserResponseText = "Teacher created successfully!";
        this.creatingUser = false;
      } catch (error) {
        this.creatingUser = false;
        console.log(error);
      }
      // finally {
      //   this.close();
      // }
    },

    openCustomerProductOrders(item) {
      // console.log("openCustomerProductOrders", item);

      // const customerOrdersPath = `/admin/productorders/customer/${
      //   item.id
      // }/${this.getCognitoAttributeValue(item.cognitoAttributes, "sub")}::${
      //   item.owner
      // }`;

      const customerOrdersPath = `/admin/productorders/customer/${
        item.teacherprofileID
      }/${encodeURIComponent(item.owner)}`;

      this.$router.push({ path: customerOrdersPath });
    },

    addCustomerProductOrders(item) {
      // console.log("addCustomerProductOrders", item);

      // const customerOrdersPath = `/admin/productorders/customer/${
      //   item.id
      // }/${this.getCognitoAttributeValue(item.cognitoAttributes, "sub")}::${
      //   item.owner
      // }/new`;

      const customerOrdersPath = `/admin/productorders/customer/${
        item.teacherprofileID
      }/${encodeURIComponent(item.owner)}/new`;

      this.$router.push({ path: customerOrdersPath });
    },

    openCustomerProductOrderQuotes(item) {
      const customerOrdersPath = `/admin/productorder-quotes/customer/${
        item.teacherprofileID
      }/${encodeURIComponent(item.owner)}`;

      this.$router.push({ path: customerOrdersPath });
    },

    addCustomerProductOrderQuotes(item) {
      const customerOrdersPath = `/admin/productorder-quotes/customer/${
        item.teacherprofileID
      }/${encodeURIComponent(item.owner)}/new`;

      this.$router.push({ path: customerOrdersPath });
    },

    async removeDuplicateProducts(teacherProfile) {
      if (
        !Array.isArray(teacherProfile.products) ||
        teacherProfile.products.length === 0
      ) {
        return;
      }
      const modelToConvert = teacherProfile;
      const productIdArray = modelToConvert.products;
      console.log("OLDproductIdArray", productIdArray);

      let newProductArray = [...new Set(productIdArray)];

      if (
        newProductArray.length === 0 ||
        JSON.stringify(newProductArray) === JSON.stringify(productIdArray)
      ) {
        return;
      }

      console.log("newProductArray", newProductArray);

      const queriedTeacherProfile = await DataStore.query(
        TeacherProfile,
        teacherProfile.id,
      );

      console.log("queriedTeacherProfile", queriedTeacherProfile);

      await DataStore.save(
        TeacherProfile.copyOf(queriedTeacherProfile, (updatedModel) => {
          updatedModel.products = newProductArray;
        }),
      );
    },

    async addType(teacherProfile) {
      console.log("teacherProfile", teacherProfile);
      const queriedTeacherProfile = await DataStore.query(
        TeacherProfile,
        teacherProfile.id,
      );

      console.log("queriedTeacherProfile", queriedTeacherProfile);

      await DataStore.save(
        TeacherProfile.copyOf(queriedTeacherProfile, (updatedModel) => {
          updatedModel.type = "TeacherProfile";
        }),
      );
    },

    async convertProducts(teacherProfile) {
      if (
        !Array.isArray(teacherProfile.products) ||
        teacherProfile.products.length === 0
      ) {
        const queriedTeacherProfile = await DataStore.query(
          TeacherProfile,
          teacherProfile.id,
        );

        await DataStore.save(
          TeacherProfile.copyOf(queriedTeacherProfile, (updatedModel) => {
            updatedModel.payfastSubscriptionPackage = {
              title: "Monthly",
              frequency: 3,
              amount: 200,
              limit: 50,
              grades: [],
              grandFathered: true,
            };
          }),
        );

        return;
      }
      const modelToConvert = teacherProfile;
      const productIdArray = modelToConvert.products;
      const queryProducts = await DataStore.query(Product, (product) =>
        product.or((product) =>
          productIdArray.reduce((c, id) => c.id("eq", id), product),
        ),
      );
      const queryProductCategories = await DataStore.query(ProductCategory);
      // console.log("queryProductCategories", queryProductCategories);

      let newProductArray = [];

      // Current date
      const currentDate = new Date();
      // console.log("currentDate.toISOString()", currentDate.toISOString());

      // Subtracting to get a date before this month
      const pastDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        currentDate.getDate(),
      );

      // Generating the ISO string timestamp from the past date
      const timeStamp = pastDate.toISOString();

      for (const productId of productIdArray) {
        const foundProduct = _.find(queryProducts, { id: productId });

        if (!foundProduct) continue;

        const foundCategory = _.find(queryProductCategories, {
          id: foundProduct.categoryId,
        });
        // console.log("foundCategory", foundCategory);

        let objToPush = {
          productId: productId,
          timeStamp: timeStamp,
        };

        if (foundCategory?.grade > "") {
          objToPush.grade = foundCategory.grade;
        }

        newProductArray.push(objToPush);
      }

      if (newProductArray.length === 0) {
        return;
      }
      // console.log("newProductArray", newProductArray);

      const queriedTeacherProfile = await DataStore.query(
        TeacherProfile,
        teacherProfile.id,
      );

      // console.log("queriedTeacherProfile", queriedTeacherProfile);

      await DataStore.save(
        TeacherProfile.copyOf(queriedTeacherProfile, (updatedModel) => {
          updatedModel.productSubscriptions = newProductArray;
          updatedModel.payfastSubscriptionPackage = {
            title: "Monthly",
            frequency: 3,
            amount: 200,
            limit: 50,
            grades: [],
            grandFathered: true,
          };
        }),
      );
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString();
    },

    filterDataTable(value, search, item) {
      let searches = search.trim().toLowerCase().split(" ");

      let stringified = JSON.stringify(item).toLowerCase();
      let found = 0;
      for (let s in searches) {
        if (stringified.indexOf(searches[s]) > -1) found++;
      }
      // console.log(found);
      return found === searches.length;
    },

    customSortProducts(a, b) {
      const lengthA = a ? parseFloat(a.length) : 0; // Default to 0 if 'a' is null/undefined
      const lengthB = b ? parseFloat(b.length) : 0; // Default to 0 if 'b' is null/undefined

      if (this.sortDesc) {
        return lengthB - lengthA; // Descending sort
      }
      return lengthA - lengthB; // Ascending sort
    },

    customSortOwner(a, b) {
      const emailA = a?.split("::").pop();
      const emailB = b?.split("::").pop();

      if (this.sortDesc) {
        return emailA.localeCompare(emailB);
      }

      return emailB.localeCompare(emailA);
    },

    customSortPayfastStatus(a, b) {
      const statusA = this.getPayFastStatus(a);
      const statusB = this.getPayFastStatus(b);

      if (!this.sortDesc) {
        return statusA.localeCompare(statusB);
      }

      return statusB.localeCompare(statusA);
    },

    getPayFastStatus(payFastResponse) {
      const responseObj = JSON.parse(payFastResponse);
      // const status_text = responseObj?.status_text
      //   ? responseObj.status_text
      //   : "";
      // const run_date = responseObj?.run_date ? responseObj.run_date : "";
      // return status_text + " UNTIL " + run_date.split("T")[0];
      return responseObj?.status_text ? responseObj.status_text : "";
    },

    getCognitoAttributeValue(attributesArray, attrName) {
      if (typeof attributesArray !== "object") return "";
      for (const attribute of attributesArray) {
        if (attribute.Name === attrName) {
          return attribute.Value;
        }
      }
      return "";
    },

    async syncTeacherProductsOrders() {
      try {
        const teacherProductsOrderSubscription = DataStore.observeQuery(
          TeacherProductsOrder,
        ).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (
              isSynced &&
              items &&
              this.syncedTeacherProductsOrderArray !== items
            ) {
              this.syncedTeacherProductsOrderArray = items;
              this.syncedTeacherProductsOrders = true;
            }
          },
          (error) => {
            console.log(error);
            this.syncedTeacherProductsOrders = true;
          },
        );

        store.commit("addSubscription", {
          model: "TeacherProductsOrder",
          sub: teacherProductsOrderSubscription,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncProductCategories() {
      try {
        const productCategorySubscription = DataStore.observeQuery(
          ProductCategory,
        ).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (
              isSynced &&
              items &&
              this.syncedProductCategoryArray !== items
            ) {
              this.syncedProductCategoryArray = items;
              this.syncedProductCategories = true;
            }
          },
          (error) => {
            console.log(error);
            this.syncedProductCategories = true;
          },
        );

        store.commit("addSubscription", {
          model: "ProductCategory",
          sub: productCategorySubscription,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncSchools() {
      try {
        const schoolSubscription = DataStore.observeQuery(School).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (isSynced && items && this.syncedSchoolArray !== items) {
              this.syncedSchoolArray = items;
              this.schoolSubscriptionSynced = true;
            }
          },
          (error) => {
            console.log(error);
            this.schoolSubscriptionSynced = true;
          },
        );

        store.commit("addSubscription", {
          model: "School",
          sub: schoolSubscription,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncReportingTeachers() {
      try {
        const reportingTeacherSubscription = DataStore.observeQuery(
          ReportingTeacher,
        ).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (
              // isSynced &&
              items?.length > 0 &&
              this.syncedReportingTeacherArray !== items
            ) {
              // console.log("syncedReportingTeacherArray", items);
              this.syncedReportingTeacherArray = items;
            }

            if (isSynced) {
              this.syncedReportingTeachers = true;
            } else {
              this.syncedReportingTeachers = false;
            }
          },
          (error) => {
            console.log(error);
            this.syncedReportingTeachers = true;
          },
        );

        store.commit("addSubscription", {
          model: "ReportingTeacher",
          sub: reportingTeacherSubscription,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncSecrets() {
      try {
        const secretSubscription = DataStore.observeQuery(Secret).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (isSynced && items && this.syncedSecretArray !== items) {
              this.syncedSecretArray = items;

              // console.log("this.syncedSecretArray", this.syncedSecretArray);

              this.secretSubscriptionSynced = true;
            }
          },
          (error) => {
            console.log(error);
            this.secretSubscriptionSynced = true;
          },
        );

        store.commit("addSubscription", {
          model: "Secret",
          sub: secretSubscription,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async syncTeacherProfiles() {
      try {
        const teacherProfileSubscription = DataStore.observeQuery(
          TeacherProfile,
        ).subscribe(
          async (snapshot) => {
            const { items, isSynced } = snapshot;
            if (isSynced && items && this.syncedTeacherProfileArray !== items) {
              this.syncedTeacherProfileArray = items;

              // Populate this.teacherProfiles with items BUT dont override .cognitoAttributes if already set but all other fields, objects must be mutable
              // this.teacherProfiles = _.cloneDeep(items);
              this.teacherProfiles = _.cloneDeep(
                items.map((item) => {
                  const foundTeacherProfile =
                    this.syncedTeacherProfileArray.find(
                      (obj) => obj.id === item.id,
                    );

                  if (foundTeacherProfile) {
                    return {
                      ...item,
                      cognitoAttributes: foundTeacherProfile.cognitoAttributes,
                    };
                  }

                  return item;
                }),
              );

              // console.log(
              //   "this.syncedTeacherProfileArray",
              //   this.syncedTeacherProfileArray
              // );

              this.teacherProfileSubscriptionSynced = true;
            }
          },
          (error) => {
            console.log(error);
            this.teacherProfileSubscriptionSynced = true;
          },
        );

        store.commit("addSubscription", {
          model: "TeacherProfile-Admin",
          sub: teacherProfileSubscription,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async getCustomers() {
      try {
        const user = await Auth.currentAuthenticatedUser().catch(() => {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        });

        if (!user) return;

        await API.get("adminlambdaapi", "/item/queryCustomers", {
          queryStringParameters: {
            userPoolId: user.pool.userPoolId,
            userName: user.username,
          },
          responseType: "text", // Ensure the response is treated as binary data
        })
          .then(async (response) => {
            // console.log("response", response);

            // Step 1: Decode the Base64 response
            const decodedBase64 = atob(response); // Decodes the Base64 string to binary

            // Step 2: Convert the decoded string to a Uint8Array (required by pako)
            const binaryArray = new Uint8Array(
              decodedBase64.split("").map((char) => char.charCodeAt(0)),
            );

            // Step 3: Inflate the gzip data using pako
            const inflatedData = pako.inflate(binaryArray, { to: "string" });

            // Step 4: Parse the inflated JSON data
            const jsonResponse = JSON.parse(inflatedData);
            // console.log("jsonResponse", jsonResponse);

            if (jsonResponse.teacherProfiles) {
              this.syncedCustomerArray = jsonResponse.teacherProfiles;
              // console.log("syncedCustomerArray", this.syncedCustomerArray);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getCategoryPath(categoryId) {
      const path = [];
      let currentId = categoryId;
      while (currentId) {
        const category = this.syncedProductCategoryArray.find(
          (cat) => cat.id === currentId,
        );
        // console.log('category', category)
        if (!category) break;
        path.push(category);
        currentId = category.parentId;
      }

      console.log("path", path);
      return path.reverse(); // From topmost parent to the category
    },

    async createOrUpdateReportingTeacherTags() {
      this.creatingReportingTags = true;
      try {
        const reportingTeachersWithoutTags = this.syncedReportingTeacherArray;
        // .filter((rT) => {
        //   return !rT.tags || rT.tags.length === 0;
        // });

        let count = reportingTeachersWithoutTags.length;

        console.log(
          "reportingTeachersWithoutTags",
          reportingTeachersWithoutTags,
        );
        for (const teacher of reportingTeachersWithoutTags) {
          console.log("count", count--);

          const paidOrders = this.syncedTeacherProductsOrderArray.filter(
            (order) =>
              order.teacherprofileID === teacher.teacherprofileID &&
              order.orderStatus === "PAID",
          );
          const tagsSet = new Set();
          for (const order of paidOrders) {
            let orderProducts;
            try {
              orderProducts = order.orderProducts;
            } catch (e) {
              console.error("Invalid orderProducts JSON", order.orderProducts);
              continue;
            }
            if (!Array.isArray(orderProducts)) continue;
            for (const product of orderProducts) {
              // const productId = product.productId;
              // if (!productId) continue;
              // const foundProduct = this.syncedProductArray.find(p => p.id === productId);
              // if (!foundProduct) continue;
              const categoryId = product.categoryId;
              if (!categoryId) continue;
              console.log("categoryId", categoryId);
              const path = this.getCategoryPath(categoryId);
              if (path.length >= 1 && path[0].slug) {
                tagsSet.add(path[0].slug); // Topmost parent
                if (path.length >= 2 && path[1].slug) {
                  tagsSet.add(`${path[0].slug}-${path[1].slug}`); // 'parentSlug-childSlug'
                  tagsSet.add(path[1].slug); // 'parentSlug-childSlug'
                }
              }
            }
          }

          // 1. Convert everything to strings and trim to avoid "hidden" differences
          const originalTags = (teacher.tags || [])
            .filter(Boolean)
            .map((t) => String(t).trim())
            .sort();

          // console.log("originalTags", originalTags);

          //add teacher.tags to tagsSet
          if (Array.isArray(teacher.tags)) {
            for (const tag of teacher.tags) {
              tagsSet.add(tag);
            }
          }

          // 2. Ensure current tags are treated exactly the same way
          const currentTags = Array.from(tagsSet)
            .filter(Boolean)
            .map((t) => String(t).trim())
            .sort();

          // console.log("currentTags", currentTags);

          // 3. Compare lengths first (Performance optimization)
          const isDifferent =
            currentTags.length !== originalTags.length ||
            currentTags.some((tag, index) => tag !== originalTags[index]);

          if (currentTags.length > 0) {
            if (isDifferent) {
              console.log("Updating tags for teacher", teacher.id, currentTags);
              await DataStore.save(
                ReportingTeacher.copyOf(teacher, (updated) => {
                  updated.tags = currentTags;
                }),
              );
            } else {
              console.log(
                "Tags are the same or no new tags found, skipping",
                teacher.id,
              );
            }
          }
        }
      } catch (error) {
        console.error("Error updating reporting teacher tags:", error);
      } finally {
        this.creatingReportingTags = false;
      }
    },

    async createOrUpdateReportingTeacherEmails() {
      this.creatingReportingData = true;

      const user = await Auth.currentAuthenticatedUser().catch(() => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      });

      const userPoolId = user.pool.userPoolId;

      // AWS Access Key ID and Secret Access Key------------------
      const accessKeyId = this.syncedSecretArray.find(
        (obj) => obj.type === "IAM",
      )?.value?.accessKeyId;

      const secretAccessKey = this.syncedSecretArray.find(
        (obj) => obj.type === "IAM",
      )?.value?.secretAccessKey;
      // ---------------------------------------------------------

      // console.log("keys", accessKeyId, secretAccessKey);

      AWS.config.update({
        region: "eu-west-2",
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey,
      });

      // Create an instance of the CognitoIdentityServiceProvider
      const CognitoIdentityServiceProvider =
        new AWS.CognitoIdentityServiceProvider();

      let allUsers = [];

      let nextPaginationToken = null;

      let fetchMore = true;

      while (fetchMore) {
        const listUsersParams = {
          AttributesToGet: ["email", "phone_number", "sub"],
          UserPoolId: userPoolId /* required */,
        };

        if (nextPaginationToken) {
          listUsersParams.PaginationToken = nextPaginationToken;
        }

        const allUsersData = await CognitoIdentityServiceProvider.listUsers(
          listUsersParams,
        ).promise();

        // console.log("allUsersData:", allUsersData);

        // const allUsers = allUsersData.Users;

        allUsers.push(...allUsersData.Users);

        // Check if there are more pages (nextToken)
        if (allUsersData.PaginationToken) {
          nextPaginationToken = allUsersData.PaginationToken;
        } else {
          // No more pages left, break the loop
          fetchMore = false;
          break;
        }
      }

      // Add users to a map with usernames as keys
      const allUsersMap = {};
      allUsers.forEach((user) => {
        allUsersMap[user.Username] = user.Attributes;
      });

      // console.log("allUsersMap:", allUsersMap);

      // Match users with teacher profiles
      this.teacherProfiles.forEach((profile) => {
        const cognitoUsername = profile.owner;

        if (allUsersMap[cognitoUsername]) {
          profile.cognitoAttributes = allUsersMap[cognitoUsername];
        }
      });

      const listGroupsParams = {
        UserPoolId: userPoolId /* required */,
      };

      const groupsData = await CognitoIdentityServiceProvider.listGroups(
        listGroupsParams,
      ).promise();
      const groups = groupsData.Groups;

      for (const group of groups) {
        let users = [];

        let nextUsersInGroupToken = null;

        let fetchMore2 = true;

        // Loop until all teacher profiles are retrieved or there are no more pages (no nextToken)
        while (fetchMore2) {
          const listUsersInGroupParams = {
            GroupName: group.GroupName,
            UserPoolId: userPoolId,
          };

          if (nextUsersInGroupToken) {
            listUsersInGroupParams.NextToken = nextUsersInGroupToken;
          }

          const usersData =
            await CognitoIdentityServiceProvider.listUsersInGroup(
              listUsersInGroupParams,
            ).promise();
          // const users = usersData.Users;

          users.push(...usersData.Users);

          // Check if there are more pages (nextToken)
          if (usersData.NextToken) {
            nextUsersInGroupToken = usersData.NextToken;
          } else {
            // No more pages left, break the loop
            fetchMore2 = false;
            break;
          }
        }

        // Add users to a map with usernames as keys
        const usersMap = {};
        users.forEach((user) => {
          usersMap[user.Username] = true;
        });

        // Match users with teacher profiles
        this.teacherProfiles.forEach((profile) => {
          const cognitoUsername = profile.owner;

          if (
            !profile.cognitoUserGroups?.includes(group.GroupName) &&
            usersMap[cognitoUsername]
          ) {
            profile.cognitoUserGroups = profile.cognitoUserGroups || [];
            profile.cognitoUserGroups.push(group.GroupName);
          }
        });
      }

      console.log("this.teacherProfiles", this.teacherProfiles);

      try {
        for (const teacherProfile of this.teacherProfiles.filter((item) =>
          item.cognitoUserGroups?.includes("teacher"),
        )) {
          // console.log("teacherProfile", teacherProfile);

          // Retrieve the values from cognitoAttributes
          const email = this.getCognitoAttributeValue(
            teacherProfile.cognitoAttributes,
            "email",
          );
          const phoneNumber = this.getCognitoAttributeValue(
            teacherProfile.cognitoAttributes,
            "phone_number",
          );
          const sub = this.getCognitoAttributeValue(
            teacherProfile.cognitoAttributes,
            "sub",
          );

          // Check if a ReportingTeacher record already exists for this teacherprofileID
          const existingTeacher = await DataStore.query(ReportingTeacher, (c) =>
            c.teacherprofileID("eq", teacherProfile.id),
          );

          const newOwner = `${sub}::${teacherProfile.owner}`;
          if (newOwner.startsWith("::")) {
            console.log(":: newOwner:", newOwner);
            // continue;
            break;
          }

          if (existingTeacher.length > 0) {
            // If record exists and email is different, update it
            const teacherRecord = existingTeacher[0];
            console.log("Found teacherRecord", teacherRecord);

            const newOwner = `${sub}::${teacherProfile.owner}`;
            if (newOwner.startsWith("::")) {
              console.log(":: newOwner:", newOwner);
            }

            await DataStore.save(
              ReportingTeacher.copyOf(teacherRecord, (updated) => {
                updated.title = teacherProfile.title
                  ? teacherProfile.title
                  : null;
                updated.name = teacherProfile.name ? teacherProfile.name : null;
                updated.surname = teacherProfile.surname
                  ? teacherProfile.surname
                  : null;
                updated.language = teacherProfile.language
                  ? teacherProfile.language
                  : null;
                updated.province = teacherProfile.province
                  ? teacherProfile.province
                  : null;
                updated.registrationDate = teacherProfile.createdAt;
                updated.teacherProfileSchoolId =
                  teacherProfile.teacherProfileSchoolId
                    ? teacherProfile.teacherProfileSchoolId
                    : null;
                updated.email = email;
                updated.phone = phoneNumber;
                updated.roles = teacherProfile.cognitoUserGroups
                  ? teacherProfile.cognitoUserGroups
                  : null;
                updated.owner = newOwner;
                // updated.productCount= Int
              }),
            );
          } else {
            // If record doesn't exist, create a new ReportingTeacher record
            await DataStore.save(
              new ReportingTeacher({
                teacherprofileID: teacherProfile.id,
                title: teacherProfile.title ? teacherProfile.title : null,
                name: teacherProfile.name ? teacherProfile.name : null,
                surname: teacherProfile.surname ? teacherProfile.surname : null,
                language: teacherProfile.language
                  ? teacherProfile.language
                  : null,
                province: teacherProfile.province
                  ? teacherProfile.province
                  : null,
                registrationDate: teacherProfile.createdAt,
                teacherProfileSchoolId: teacherProfile.teacherProfileSchoolId,
                email: email,
                phone: phoneNumber,
                roles: teacherProfile.cognitoUserGroups
                  ? teacherProfile.cognitoUserGroups
                  : null,
                owner: newOwner,
                // productCount: Int
              }),
            );
            console.log(
              `Created new ReportingTeacher for teacherprofileID: ${teacherProfile.id}`,
            );
          }
        }

        this.creatingReportingData = false;
      } catch (error) {
        console.log(error);
        this.creatingReportingData = false;
      }
    },

    async deleteNonTeacherOrAdminUsers(testMode = false) {
      this.deletingUsers = true; // Assuming you have a data property to track deletion status

      try {
        // Get the authenticated user and user pool ID
        const user = await Auth.currentAuthenticatedUser().catch(() => {
          throw new Error("Failed to get authenticated user");
        });

        const userPoolId = user.pool.userPoolId;

        // AWS Access Key ID and Secret Access Key
        const accessKeyId = this.syncedSecretArray.find(
          (obj) => obj.type === "IAM",
        )?.value?.accessKeyId;

        const secretAccessKey = this.syncedSecretArray.find(
          (obj) => obj.type === "IAM",
        )?.value?.secretAccessKey;

        if (!accessKeyId || !secretAccessKey) {
          throw new Error("AWS credentials not found");
        }

        // Configure AWS SDK
        AWS.config.update({
          region: "eu-west-2",
          accessKeyId: accessKeyId,
          secretAccessKey: secretAccessKey,
        });

        // Create an instance of the CognitoIdentityServiceProvider
        const CognitoIdentityServiceProvider =
          new AWS.CognitoIdentityServiceProvider();

        // Fetch all users with pagination
        let allUsers = [];
        let nextPaginationToken = null;
        let fetchMore = true;

        while (fetchMore) {
          const listUsersParams = {
            UserPoolId: userPoolId,
          };

          if (nextPaginationToken) {
            listUsersParams.PaginationToken = nextPaginationToken;
          }

          const allUsersData = await CognitoIdentityServiceProvider.listUsers(
            listUsersParams,
          ).promise();
          allUsers.push(...allUsersData.Users);

          nextPaginationToken = allUsersData.PaginationToken || null;
          fetchMore = !!nextPaginationToken;
        }

        console.log(`Found ${allUsers.length} users in the user pool`);

        // Process each user
        for (const user of allUsers) {
          const username = user.Username;

          // Check user's groups
          const listGroupsParams = {
            Username: username,
            UserPoolId: userPoolId,
          };

          const userGroupsData =
            await CognitoIdentityServiceProvider.adminListGroupsForUser(
              listGroupsParams,
            ).promise();
          const userGroups = userGroupsData.Groups.map(
            (group) => group.GroupName,
          );

          // Skip deletion if user is in 'teacher' or 'admin' group
          if (userGroups.includes("teacher") || userGroups.includes("admin")) {
            console.log(
              `Skipping user ${username} (in ${userGroups.join(", ")} group)`,
            );
            continue;
          }

          // Delete the user
          try {
            await CognitoIdentityServiceProvider.adminDeleteUser({
              UserPoolId: userPoolId,
              Username: username,
            }).promise();
            console.log(`Deleted user ${username}`);

            // If in test mode, stop after deleting one user
            if (testMode) {
              console.log("Test mode: Stopping after deleting one user");
              break;
            }

            // Throttle to stay under 25 requests per second (40ms delay)
            await new Promise((resolve) => setTimeout(resolve, 40));
          } catch (error) {
            console.error(`Failed to delete user ${username}:`, error);
            // In test mode, throw the error to halt execution
            if (testMode) {
              throw error;
            }
          }
        }

        console.log("User deletion process completed");
        this.deletingUsers = false;
      } catch (error) {
        console.error("Error in deleteNonTeacherOrAdminUsers:", error);
        this.deletingUsers = false;
        throw error;
      }
    },

    // async createOrUpdateReportingTeacherEmails() {
    //   this.creatingReportingData = true;
    //   for (const syncedCustomerArrayItem of this.syncedCustomerArray) {
    //     console.log("syncedCustomerArrayItem", syncedCustomerArrayItem);

    //     try {
    //       // Retrieve the email from cognitoAttributes
    //       const email = this.getCognitoAttributeValue(
    //         syncedCustomerArrayItem.cognitoAttributes,
    //         "email"
    //       );

    //       // Check if a ReportingTeacher record already exists for this teacherprofileID
    //       const existingTeacher = await DataStore.query(ReportingTeacher, (c) =>
    //         c.teacherprofileID("eq", syncedCustomerArrayItem.id)
    //       );

    //       if (existingTeacher.length > 0) {
    //         // If record exists and email is different, update it
    //         const teacherRecord = existingTeacher[0];
    //         if (teacherRecord.email !== email) {
    //           await DataStore.save(
    //             ReportingTeacher.copyOf(teacherRecord, (updated) => {
    //               updated.email = email;
    //             })
    //           );
    //           console.log(
    //             `Updated ReportingTeacher for teacherprofileID: ${syncedCustomerArrayItem.id}`
    //           );
    //         } else {
    //           console.log(
    //             `No update needed for teacherprofileID: ${syncedCustomerArrayItem.id}`
    //           );
    //         }
    //       } else {
    //         // If record doesn't exist, create a new ReportingTeacher record
    //         await DataStore.save(
    //           new ReportingTeacher({
    //             teacherprofileID: syncedCustomerArrayItem.id,
    //             email: email,
    //           })
    //         );
    //         console.log(
    //           `Created new ReportingTeacher for teacherprofileID: ${syncedCustomerArrayItem.id}`
    //         );
    //       }
    //       this.creatingReportingData = false;
    //     } catch (error) {
    //       console.log(error);
    //       this.creatingReportingData = false;
    //     }
    //   }
    // },

    //     async deCompressGzipRequest(data) {
    //     const buffer = [];
    //     const gunzip = zlib.createGunzip();

    //     // Event handler for handling data chunks during decompression
    //     gunzip.on('data', (chunk) => {
    //         buffer.push(chunk);
    //     });

    //     // Promise to handle the end of decompression
    //     const decompressPromise = new Promise((resolve, reject) => {
    //         // Event handler for handling the end of decompression
    //         gunzip.on('end', () => {
    //             try {
    //                 const decompressedBuffer = Buffer.concat(buffer);
    //                 const jsonData = JSON.parse(decompressedBuffer);
    //                 resolve(jsonData);
    //             } catch (error) {
    //                 reject(error);
    //             }
    //         });

    //         // Event handler for handling errors during decompression
    //         gunzip.on('error', (err) => {
    //             console.error('Error during decompression:', err);
    //             reject(err);
    //         });
    //     });

    //     // Initiate decompression with the base64-encoded data
    //     gunzip.end(Buffer.from(data, 'base64'));

    //     return decompressPromise;
    // },
  },

  beforeDestroy() {
    store.commit("removeSubscriptions", [
      "School",
      "ReportingTeacher",
      "Secret",
      "TeacherProfile-Admin",
      "TeacherProductsOrder",
      "ProductCategory",
    ]);

    store.commit("removeDatastorePredicates", [
      "School",
      "ReportingTeacher",
      "Secret",
      "TeacherProfile",
      "TeacherProductsOrder",
      "ProductCategory",
    ]);
  },
};
</script>
